export default __webpack_public_path__ + "static/media/videoPoster1.606dbf7f.jpg";